import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';
import styled from 'styled-components';
import SignContainer from './containers/SignContainer';
import AvnfrGGContainer from './containers/avnfr-gg/AvnfrGGContainer';
import ResomContainer from './containers/resom/ResomContainer';
import ResomSpaceDetailContainer from './containers/resom/ResomSpaceDetailContainer';
import ResomEventContainer from './containers/resom/ResomEventContainer';
import ResomEventDetailContainer from './containers/resom/ResomEventDetailContainer';
import ResomDataContainer from './containers/resom/ResomDataContainer';
import AvnfrGGDataContainer from './containers/avnfr-gg/AvnfrGGDataContainer';
import AvnfrGGSpaceDetailContainer from './containers/avnfr-gg/AvnfrGGSpaceDetailContainer';
import DaekyoContainer from './containers/daekyo/DaekyoContainer';
import DaekyoSpaceDetailContainer from './containers/daekyo/DaekyoSpaceDetailContainer';
import DaekyoEventContainer from './containers/daekyo/DaekyoEventContainer';
import DaekyoDataContainer from './containers/daekyo/DaekyoDataContainer';
import DaekyoUserContainer from './containers/daekyo/DaekyoUserContainer';
import MaunaContainer from './containers/mauna/MaunaContainer';
import MaunaDataContainer from './containers/mauna/MaunaDataContainer';
import MaunaSpaceDetailContainer from './containers/mauna/MaunaSpaceDetailContainer';
import MaunaUserContainer from './containers/mauna/MaunaUserContainer';
import MaunaMissionContainer from './containers/mauna/MaunaMissionContainer';
import MaunaMissionDetailContainer from './containers/mauna/MaunaMissionDetailContainer';
import MaunaRewardContainer from './containers/mauna/MaunaRewardContainer';
import MaunaRewardDetailContainer from './containers/mauna/MaunaRewardDetailContainer';
// 보호된 라우트 컴포넌트
const ProtectedRoute = ({
  children,
  requiredSession,
}: {
  children: React.ReactNode;
  requiredSession: string;
}) => {
  const session = sessionStorage.getItem('sign');

  let isAuthorized = false;

  if (
    requiredSession === 'resom' &&
    session === import.meta.env.VITE_SECRET_RESOM_CODE
  ) {
    isAuthorized = true;
  } else if (
    requiredSession === 'avnfr-gg' &&
    session === import.meta.env.VITE_SECRET_AVNFR_GG_CODE
  ) {
    isAuthorized = true;
  } else if (
    requiredSession === 'daekyo' &&
    (session === import.meta.env.VITE_SECRET_DAEKYO_CODE || session === 'daekyo_secret')
  ) {
    isAuthorized = true;
  } else if (
    requiredSession === 'mauna' &&
    (session === import.meta.env.VITE_SECRET_MAUNA_CODE || session === 'mauna_secret')
  ) {
    isAuthorized = true;
  }

  if (!isAuthorized) {
    return <Navigate to="/sign" replace />;
  }

  return <>{children}</>;
};

// 와일드카드 리다이렉트 컴포넌트
const WildcardRedirect = () => {
  const session = sessionStorage.getItem('sign');

  // 세션 값에 따라 적절한 경로로 리다이렉트
  if (session === import.meta.env.VITE_SECRET_RESOM_CODE) {
    return <Navigate to="/resom/space" replace />;
  } else if (session === import.meta.env.VITE_SECRET_AVNFR_GG_CODE) {
    return <Navigate to="/avnfr-gg/space" replace />;
  } else if (session === import.meta.env.VITE_SECRET_DAEKYO_CODE || session === 'daekyo_secret') {
    return <Navigate to="/daekyo/space" replace />;
  } else if (session === import.meta.env.VITE_SECRET_MAUNA_CODE || session === 'mauna_secret') {
    return <Navigate to="/mauna/space" replace />;
  }

  // 인증되지 않은 사용자는 로그인 페이지로 리다이렉트
  return <Navigate to="/sign" replace />;
};

// 로그인 페이지 리다이렉트 컴포넌트
const SignRedirect = () => {
  const session = sessionStorage.getItem('sign');

  // 이미 로그인된 경우 세션 값에 따라 적절한 경로로 리다이렉트
  if (session === import.meta.env.VITE_SECRET_RESOM_CODE) {
    return <Navigate to="/resom/space" replace />;
  } else if (session === import.meta.env.VITE_SECRET_AVNFR_GG_CODE) {
    return <Navigate to="/avnfr-gg/space" replace />;
  } else if (session === import.meta.env.VITE_SECRET_DAEKYO_CODE || session === 'daekyo_secret') {
    return <Navigate to="/daekyo/space" replace />;
  } else if (session === import.meta.env.VITE_SECRET_MAUNA_CODE || session === 'mauna_secret') {
    return <Navigate to="/mauna/space" replace />;
  }

  // 로그인되지 않은 경우 로그인 페이지 표시
  return <SignContainer />;
};

const router = () => {
  return createBrowserRouter([
    {
      path: '/sign',
      element: <SignRedirect />,
    },
    {
      path: '/resom/space',
      element: (
        <ProtectedRoute requiredSession="resom">
          <ResomContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/resom/space/:id',
      element: (
        <ProtectedRoute requiredSession="resom">
          <ResomSpaceDetailContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/resom/event',
      element: (
        <ProtectedRoute requiredSession="resom">
          <ResomEventContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/resom/event/:id',
      element: (
        <ProtectedRoute requiredSession="resom">
          <ResomEventDetailContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/resom/data',
      element: (
        <ProtectedRoute requiredSession="resom">
          <ResomDataContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/avnfr-gg/space',
      element: (
        <ProtectedRoute requiredSession="avnfr-gg">
          <AvnfrGGContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/avnfr-gg/space/:id',
      element: (
        <ProtectedRoute requiredSession="avnfr-gg">
          <AvnfrGGSpaceDetailContainer />
        </ProtectedRoute>
      ),
    },
    // {
    //   path: '/avnfr-gg/event',
    //   element: (
    //     <ProtectedRoute requiredSession="avnfr-gg">
    //       <AvnfrGGEventContainer />
    //     </ProtectedRoute>
    //   ),
    // },
    {
      path: '/avnfr-gg/data',
      element: (
        <ProtectedRoute requiredSession="avnfr-gg">
          <AvnfrGGDataContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/daekyo/space',
      element: (
        <ProtectedRoute requiredSession="daekyo">
          <DaekyoContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/daekyo/space/:id',
      element: (
        <ProtectedRoute requiredSession="daekyo">
          <DaekyoSpaceDetailContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/daekyo/event',
      element: (
        <ProtectedRoute requiredSession="daekyo">
          <DaekyoEventContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/daekyo/data',
      element: (
        <ProtectedRoute requiredSession="daekyo">
          <DaekyoDataContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/daekyo/user',
      element: (
        <ProtectedRoute requiredSession="daekyo">
          <DaekyoUserContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/mauna/space',
      element: (
        <ProtectedRoute requiredSession="mauna">
          <MaunaContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/mauna/space/:id',
      element: (
        <ProtectedRoute requiredSession="mauna">
          <MaunaSpaceDetailContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/mauna/mission',
      element: (
        <ProtectedRoute requiredSession="mauna">
          <MaunaMissionContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/mauna/mission/:id',
      element: (
        <ProtectedRoute requiredSession="mauna">
          <MaunaMissionDetailContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/mauna/reward',
      element: (
        <ProtectedRoute requiredSession="mauna">
          <MaunaRewardContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/mauna/reward/:id',
      element: (
        <ProtectedRoute requiredSession="mauna">
          <MaunaRewardDetailContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/mauna/data',
      element: (
        <ProtectedRoute requiredSession="mauna">
          <MaunaDataContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '/mauna/user',
      element: (
        <ProtectedRoute requiredSession="mauna">
          <MaunaUserContainer />
        </ProtectedRoute>
      ),
    },
    {
      path: '*',
      element: <WildcardRedirect />,
    },
  ]);
};

const RouterComponent = () => {
  return (
    <ContentWrapper>
      <RouterProvider router={router()} />
    </ContentWrapper>
  );
};

// 스타일 컴포넌트 정의
const ContentWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #f5f5f5;
`;
export default RouterComponent;
